<template>
    <div>
        <div class="container-fluid">
            <div>
                <b-card  border-variant="secondary"  header-text-variant="black" >
                    <div slot="header">
                        <h3 align="center">Ajuste de Stock</h3>
                    </div>
                    <vue-snotify></vue-snotify>
                    <div class="contenedor">
                        <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <h4>Productos</h4>
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mb-2">
                                    <b-form-select class="p-1" v-model="parambus" slot="append">
                                    <option :value="'code'">Código</option>
                                    <option :value="'name'">Descripción</option>
                                    <option :value="'category'">Categoría</option>
                                    </b-form-select>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="6">
                                    <b-form-input
                                    placeholder="Ingresa tu busqueda"
                                    @change="searchProduct()"
                                    v-model="cadenabusqueda"
                                    ></b-form-input>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                                    <b-button variant="success" v-if="!cargandoproducto" @click="searchProduct()">
                                        Buscar
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                    <b-button variant="secondary" v-else>
                                         <i class="fa fa-spin fa-spinner"></i>
                                    </b-button>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                                    <b-button variant="secondary" @click="listProduct">
                                     <i class="fa fa-sync-alt"></i>
                                    </b-button>
                                </b-col>
                            </b-row>
                            <div v-if="cargando">
                                <div align="center" class="mb-5">
                                    <h3><i class="fas fa-spin fa-spinner"></i><strong>Cargando...</strong></h3> 
                                </div>
                            </div>
                            <div v-else>
                            <b-table 
                                head-variant="light" 
                                responsive 
                                small 
                                :items="productos" 
                                :fields="Listado_stock" 
                                :outlined="outlined"
                                >
                                <template v-if="row.item && row.item.category && row.item.category !='' " slot="categoria" slot-scope="row">
                                    <span >{{row.item.category.descripcion}}</span>
                                </template>
                                <template slot="updated_at" slot-scope="row">
                                    {{row.item.updated_at | moment('D/M/Y hh:mm:ss')}}
                                </template>
                                <template slot="acciones" slot-scope="row">
                                <b-button  
                                    @click="reciveLista(row,row.index,row.item)" 
                                    class="btn-sm" 
                                    variant="success"
                                    :disabled="itemExpandido !== null && itemExpandido !== row.item.idProducto">
                                    <template v-if="!row.item.reciveLista">
                                         <i class="fas fa-boxes"></i>
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-minus"></i>
                                     </template>
                                </b-button>
                                </template>
                                <template slot="row-details" slot-scope="row">
                                <b-card>
                                    <h3>Ajuste de producto !</h3>
                                    <hr>
                                    <template>
                                        <b-row>
                                            <b-col cols="12" sm="5" md="5" lg="4" xl="2">   
                                                <b-form-input 
                                                    placeholder="Stock" 
                                                    v-model="ajusteStock" 
                                                    type="number" >
                                                </b-form-input>        
                                            </b-col>
                                            <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                                <b-form-select  
                                                    v-model="selected" 
                                                    :options="options" 
                                                    size="sm" >
                                                </b-form-select>
                                            </b-col>
                                            <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                                <div>
                                                <b-form-textarea
                                                    id="textarea"
                                                    v-model="motivoajuste"
                                                    placeholder="Motivo de Ajuste Stock...(Obligatorio)"
                                                    rows="3"
                                                    max-rows="6"
                                                    maxlength="50"
                                                ></b-form-textarea>                                  
                                                </div>
                                            </b-col>
                                            <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                                <div>
                                                <b-form-textarea
                                                    id="textarea"
                                                    v-model="observaciones"
                                                    placeholder="Alguna Observación...(Opcional)"
                                                    rows="3"
                                                    max-rows="6"
                                                    maxlength="50"
                                                    limi
                                                ></b-form-textarea>                                  
                                                    </div>
                                            </b-col>                                  
                                        </b-row>
                                        <b-row>
                                            <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                                                <template v-if="guardarAjuste">
                                                    <div>
                                                        <b-button variant="success" @click="sendAjuste()">Editar</b-button>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div>
                                                        <b-button variant="success" disabled>Guardando... <i class="fa fa-spin fa-spinner"></i></b-button> 
                                                    </div>
                                                </template>
                                           
                                            </b-col>
                                        </b-row>      
                                    </template>
                                </b-card>
                                </template>
                            </b-table>
                            </div>
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="6">
                                    <p>Mostrando del {{desdePro}} al {{hastaPro}} de un total de {{totalPro}} registros</p>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="6">
                                    <b-pagination
                                    size="sm"
                                    v-model.number="pactual"
                                    :total-rows="totalPro"
                                    :per-page="limitePro"
                                    @input="listProduct"
                                    aria-controls="my-table"
                                    ></b-pagination>
                                </b-col>
                            </b-row>
                        </b-col>
                        </b-row>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name:'AjusteInventario',
    data: () =>{
        return{
            listado:[],
             listado_fields:[        
                {key:"almacen",label:"Almacen"},
                {key:"fechaIngreso",label:"Fecha Ingreso"},
                {key:"acciones",label:"Acciones"}
            ],
            listado_productos:[  
                {key:"index",label:"Item"},
                {key:"codigo",label:"Cod.Producto"},      
                {key:"descripcion",label:"Producto"},
                {key:"cantidad",label:"Stock Inicial (referencial)"},
                {key:"acciones",label:"Ajuste"}
            ],
            productos:[],
             Listado_stock:[  
                { key: "codigo", label: "Codigo Producto", sorteable: true },
                { key: "unidadMedida", label: "Unidad.M", sorteable: true },
                { key: "updated_at", label:"Fecha Ajuste"},
                { key: "categoria", label: " Categoria Prod.", sorteable: true },
                { key: "descripcion", label: "Descripcion", sorteable: true },
                { key: "stock", label: "Stock", sorteable: true },  
                { key: "acciones",label:"Ajuste"}   
            ],
            outlined:true,
            selected: 1,
            options:[
                { value: 1, text: 'Ingreso Stock' },
                { value: 2, text: 'Salida Stock' },
            ],
            observaciones:'',
            motivoajuste:'',
            cantidadItem:'',
            ajusteStock:'',

            almacenAI:'Almacen Principal',
            serieAI:'AI001',
            fechaajuste:'',
            monedaAI:'PEN',
            reciveItems:[],
            reciveItemA:{},
            tipoajuste:'',
            adicional: null,
            reciveajuste:{},

            pactual: 1,
            limitePro: 19,
            desdePro: 0.0,
            hastaPro: 0.0,
            totalPro: 0.0,              
            ordenPro: "desc",
            
            parambus: "code",
            cadenabusqueda: "",
            cargandoproducto: false,
            cargando:false,
            itemExpandido: null,
            guardarAjuste:true,
          
        }
    },
    mounted(){
        this.listProduct();
        this.tipoAjusteI();
    },
    watch: {
        selected(){
        let  val = this.tipoajuste
            if(this.selected == 1){
                this.tipoajuste = 'Ingreso Stock'       
            }else if(this.selected == 2){  
                this.tipoajuste = 'Salida Stock'
                    }
            return val;     
         },
     },
    methods:{
    customFormatter: function (date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
    listProduct: function() {
        this.cargando = true;
      axios
        .post(process.env.VUE_APP_API_URL + "productos/listar", {
          token: this.$store.getters.userToken,
          page: this.pactual,
          limit: this.limitePro,
          order: this.ordenPro
        })
        .then(
          response => (
            (this.productos = response.data.producto.data),
            (this.totalPro = response.data.producto.total),
            (this.desdePro = response.data.producto.from),
            (this.hastaPro = response.data.producto.to),
            (this.cargando = false),
            this.itemExpandido = null
          )
        )
        .catch(function(error) {
          this.$snotify.error(error.response.data.response.message, "Error");
          this.cargando = false;
        });
    },
    reciveLista(row, index,item) {
        if(row.detailsShowing){
            row.toggleDetails()
            this.productos[index].reciveLista = false;
            this.itemExpandido = null; //se agrego

            this.ajusteStock ='';
            this.motivoajuste ='';
            this.motivoajuste ='';
            this.observaciones ='';
        }else{
            this.productos[index].reciveLista = true
            this.itemExpandido = item.idProducto; //se agrego
            row.toggleDetails()
            this.reciveajuste = item;
        }       
    },
    sendAjuste(){
        if(this.ajusteStock !='' && this.motivoajuste !=''){
        this.guardarAjuste = false;
        this.reciveajuste;
        this.reciveItemA.idProducto =  this.reciveajuste.idProducto;
        this.reciveItemA.codigo =  this.reciveajuste.codigo;
        this.reciveItemA.codigoProductoSunat =  this.reciveajuste.codigoProductoSunat;
        this.reciveItemA.codigoProductoGs1 =  this.reciveajuste.codigoProductoGs1;
        this.reciveItemA.unidadMedida =  this.reciveajuste.unidadMedida;
        this.reciveItemA.cantidad = this.ajusteStock;
        this.reciveItemA.descripcion =  this.reciveajuste.descripcion;
        this.reciveItemA.precioUnitario =  this.reciveajuste.precioUnitario;
        this.reciveItemA.precioTotal =  this.ajusteStock * this.reciveajuste.precioUnitario;
        this.reciveItemA.tipoAfectacionIgv =  this.reciveajuste.tipoAfectacionIgv;
        if(this.reciveajuste.category == null){
            this.reciveItemA.idCategoria = ''
        }else{
            this.reciveItemA.idCategoria =  this.reciveajuste.category.idCategoria;
        }
        this.reciveItems.push(this.reciveItemA);

        axios
        .post(process.env.VUE_APP_API_URL + "ajusteinventario/ingreso",{
        token: this.$store.getters.userToken,
        almacen: this.almacenAI,
        serie: this.serieAI,
        fechaajuste: this.customFormatter(),
        moneda: this.monedaAI,
        motivoajuste: this.motivoajuste,
        accion: this.tipoAjusteI(),
        adicional: this.adicional,
        total: parseFloat(this.preciototalAI()),
        observaciones: this.observaciones,
        items: this.reciveItems
        })
        .then(response =>(
            this.$snotify.success(response.data.msg, 'Éxito'),
            this.listProduct(),
            this.clear()     
        ))
        .catch(response =>(
            this.$snotify.error(error.response.data, 'Error')
        ))
    }else{
        this.$snotify.warning('Completar todos los Campos',"Cuidado!")
    }
    },
    clear(){
        this.motivoajuste = '',
        this.observaciones = '',
        this.ajusteStock = '',
        this.reciveItems = [],
        this.guardarAjuste = true;
    },
    tipoAjusteI(){
        let  val = this.tipoajuste
            if(this.selected == 1){
                this.tipoajuste = 'Ingreso Stock'       
            }else if(this.selected == 2){  
                this.tipoajuste = 'Salida Stock'
                    }
            return val;     
         },
    preciototalAI: function() {
        let val = 0.0;
        this.reciveItems.forEach(function(element) {
                  val += parseFloat(element.precioTotal);
                });
        return val;
      },     
    searchProduct: function() {
        this.cargando = true;
        this.cargandoproducto = true;
      axios
        .post(process.env.VUE_APP_API_URL + "productos/buscar", {
          token: this.$store.getters.userToken,
          filtro: this.parambus,
          p: this.cadenabusqueda
          // 'name, code, codesunat, codegs1'
          // Parametro ej: Shoes -> sho
        })
        .then(
          response => (
            (this.productos = response.data.response),
            (this.cargandoproducto = false),
             this.cargando = false,
            (this.cadenabusqueda = "")
          )
        )
        .catch(
          error => (
            (this.cargandoproducto = false),
             this.cargando = false,
            this.$snotify.error(error.response.data.response.message, "Error")
          )
        );
    },   
    }
}
</script>

<style scoped>

</style>